import React, { useState } from "react";
import {
  useCommittees,
  useCommitteeStatus,
  useEditCommittee,
} from "../hooks/useCommittees";

import { Dashboard } from "../../DashboardPage/useDashboard";
import { LoadingCommitteeHeader } from "../CommitteeHeader/CommitteeHeader";
import AddCommitteeModal from "../AddCommitteeModal";
import CommitteesItem from "../CommitteesItem";
import styles from "./ArchivedCommittees.module.css";
import Auth from "shared/@auth";

export function ArchivedCommittees() {
  const { hasPermission } = Auth.useContainer();
  const readOnly = !hasPermission("management-team.admins");
  const { data: dashboard, refetchDashboard } = Dashboard.useContainer();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCommittee, setEditingCommittee] = useState({
    title: undefined,
    description: undefined,
    yearStarted: undefined,
    members: [],
  });

  const {
    data: committees,
    isLoading,
    isError,
    error,
  } = useCommittees("archived");
  const unArchiveCommittee = useCommitteeStatus("Current");
  const deleteCommittee = useCommitteeStatus("Deleted");
  const editCommittee = useEditCommittee();

  const handleUnarchive = (id) => {
    unArchiveCommittee(id);
  };

  const handleDelete = (id) => {
    deleteCommittee(id);
  };

  const handleEditCommittee = (id) => {
    setShowEditModal(true);
    const index = committees.findIndex((committee) => committee._id === id);
    const editing = {
      _id: committees[index]._id,
      ...committees[index],
    };
    setEditingCommittee({ ...editing });
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setEditingCommittee({
      title: "",
      description: "",
      year: "",
      members: [],
    });
    setShowEditModal(false);
  };

  const handleSaveEditModal = (form, members) => {
    const index = committees.findIndex(
      (committee) => committee._id === editingCommittee._id
    );
    const committee = {
      committeeId: committees[index]._id,
      ...form,
      members: [...members],
    };
    console.log(committee);
    editCommittee(committee);
    setShowEditModal(false);
  };

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      {showEditModal && editingCommittee && (
        <AddCommitteeModal
          isOpen={true}
          committeeMember={editingCommittee}
          onClose={() => handleCloseEditModal()}
          onSave={handleSaveEditModal}
        />
      )}
      {isLoading || !dashboard || !dashboard.users ? (
        <div className={styles.committeeContainer}>
          <LoadingCommitteeHeader />
          <LoadingCommitteeHeader />
          <LoadingCommitteeHeader />
          <LoadingCommitteeHeader />
        </div>
      ) : committees.length === 0 ? (
        <h2 style={{ width: "100%", textAlign: "center" }}>
          No Archived Committees Found!
        </h2>
      ) : (
        committees.map(
          (committee, index) =>
            committee.status === "Archived" && (
              <CommitteesItem
                key={index}
                committee={committee}
                archived={true}
                onArchive={() => handleUnarchive(committee._id)}
                onEdit={() => handleEditCommittee(committee._id)}
                onDelete={() => handleDelete(committee._id)}
                onUpdateCompleted={() => refetchDashboard()}
                onSwapCompleted={() => refetchDashboard()}
                readOnly={readOnly}
              />
            )
        )
      )}
    </>
  );
}
